<template>
  <div class="wrapper">
    <div class="flex justify-center mb-6">
      <div class="w-3/4 bg-gray-100 bg-opacity-50" style="min-height: 55vh">
        <div class="flex justify-center mb-4 mt-12" style="max-height: 10rem">
          <!-- <img src="../../assets/img/MOH_logo.png" style="max-height: 7rem" /> -->
          <span class="text-unauthorized">401</span>
        </div>
        <div class="self-center justify-center text-center">
          <div class="text--primary font-weight-medium">
            WE'RE SORRY, YOUR REQUEST IS UNAUTHORIZED!!
          </div>
          <div class="text--primary back-text">PLEASE CLICK THE "GO HOME" BUTTON BELOW TO TAKE YOU BACK TO HOME</div>
        </div>

        <div class="self-center justify-center text-center">
          <div class="text--primary font-weight-medium">
            <v-btn color="primary mt-4 mb-5" small @click="goBack()">Go Home</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDefaultRouteForUser, getUser} from '../../utils/helper';

export default {
  name: 'Unauthorized',
  methods: {
    goBack() {
      this.$router.push(getDefaultRouteForUser(getUser()));
    }
  }
}
</script>

<style scoped>
.wrapper {
  align-items: center;
  background-color: #e2e2e5;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.text-unauthorized {
  font-weight: 900;
  font-size: xxx-large;
  color: lightgray;
}

.back-text {
  font-size: 11px;
  font-weight: 400;
}
</style>
